// extracted by mini-css-extract-plugin
export var aiStarIcon = "_kj-2";
export var container = "_kj-4";
export var dismissButton = "_kj-3";
export var hasPaddingBottom = "_kj-6";
export var last = "_kj-e";
export var scrollbarThumb = "_kj-c";
export var scrollbarTrack = "_kj-b";
export var selected = "_kj-9";
export var spin = "_kj-1";
export var spinning = "_kj-0";
export var suggestionItem = "_kj-d";
export var suggestionsPanel = "_kj-5";
export var tonePill = "_kj-8";
export var tonesContainer = "_kj-7";
export var unselected = "_kj-a";